import React, { useEffect, useState } from "react";
import "./AgenticeucStyle.css";
import SoftwareInstallation from "../Catalogue-Library/SoftwareInstallation";
import EUC from "../Catalogue-Library/EUC";



function AgenticEUCDashboard() {
       const [authToken, setToken] = useState("");
       const [modulesData, setModulesData] = useState([]);
       const [isLoggedIn, setIsLoggedIn] = useState(false);
       const [isLoading, setIsLoading] = useState(true);
       const userId = 209;
       const moduleName = "iNSPIRE";

         useEffect(() => {
           const login = async () => {
             try {
               const response = await fetch(
                 "https://staging.gyaaniworkbot.com/gyani/login",
                 {
                   method: "POST",
                   headers: {
                     "Content-Type": "application/json",
                   },
                   body: JSON.stringify({
                     loginname: "lnt_uploader",
                     code: "lnt_invoice",
                     password: "12345",
                   }),
                 }
               );
       
               if (!response.ok) {
                 throw new Error("Network response was not ok");
               }
       
               const data = await response.json();
               const authToken = data.details[0].token;
               console.log("Auth Token:", authToken);
               setToken(authToken);
               setIsLoggedIn(true);
             } catch (error) {
               console.error("Login Error:", error);
             } finally {
               setIsLoading(false);
             }
           };
       
           login();
         }, []);
       
         const fetchData = async (moduleName, authToken) => {
           const moduleURL = `https://staging.gyaaniworkbot.com/inspire/?token=${authToken}`;
           window.open(moduleURL, "_blank");
         };



  return (
    <>
      <main>
        <section className="dashbaord section mb-8">
          <div className="row">
            <div className="text-center text-2xl font-semibold mb-4">
              <h4>Automation Catalogue Library </h4>
            </div>

            <div className="container">
              <div className="row">
                <div class="grid md:grid-cols-3">
               
                <SoftwareInstallation />

          <EUC />

                  <div class="max-w-sm w-full lg:max-w-full shadow-lg shadow-cyan-500/50 ...">
                    <div class="bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                      <div class="flex items-center forImage">
                        <img
                          class="rounded-full mr-4"
                          src="https://ik.imagekit.io/ifixtechglobal/auto-Bot/checkmark.png?updatedAt=1715601130817"
                          alt=""
                        />
                        <div
                          class="text-lg"
                          onClick={() => fetchData(moduleName, authToken)}
                        >
                          <p class="text-gray-900 leading-none">
                            Platform Engineering
                          </p>{" "}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="max-w-sm w-full lg:max-w-full shadow-lg shadow-cyan-500/50 ...">
                    <div class="bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                      <div class="flex items-center forImage">
                        <img
                          class="rounded-full mr-4"
                          src="https://ik.imagekit.io/ifixtechglobal/auto-Bot/checkmark.png?updatedAt=1715601130817"
                          alt=""
                        />
                        <div
                          class="text-lg"
                          onClick={() => fetchData(moduleName, authToken)}
                        >
                          <p class="text-gray-900 leading-none">
                            Network Services
                          </p>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="max-w-sm w-full lg:max-w-full shadow-lg shadow-cyan-500/50 ...">
                    <div class="bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                      <div class="flex items-center forImage">
                        <img
                          class="rounded-full mr-4"
                          src="https://ik.imagekit.io/ifixtechglobal/auto-Bot/checkmark.png?updatedAt=1715601130817"
                          alt=""
                        />
                        <div
                          class="text-lg"
                          onClick={() => fetchData(moduleName, authToken)}
                        >
                          <p class="text-gray-900 leading-none">Data Center</p>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="max-w-sm w-full lg:max-w-full shadow-lg shadow-cyan-500/50 ...">
                    <div class="bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                      <div class="flex items-center forImage">
                        <img
                          class="rounded-full mr-4"
                          src="https://ik.imagekit.io/ifixtechglobal/auto-Bot/checkmark.png?updatedAt=1715601130817"
                          alt=""
                        />
                        <div
                          class="text-lg"
                          onClick={() => fetchData(moduleName, authToken)}
                        >
                          <p class="text-gray-900 leading-none">
                            Cloud Services
                          </p>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}

export default AgenticEUCDashboard
